/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 14:48:20
 * @LastEditTime: 2019-08-14 15:01:57
 * @LastEditors: Please set LastEditors
 */
import { PltRes } from "@szgc/plt-core-v2";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Loading } from "element-ui";

let loading: any = null;
const minTime = 120 // 请求小于此时间则不显示loading效果
const delayTime = 40 // 串行的相邻请求小于该时间则延迟loading效果结束
const requestNum = 0

const instance = axios.create({
  baseURL: "/",
  timeout: 10000
});

instance.interceptors.request.use((config: any) => {
  loading = Loading.service({
    fullscreen: true,
    lock: true,
    text: "加载中...",
  });
  return config;
});

instance.interceptors.response.use(
  (resp: any) => {
    loading && loading.close();
    if (resp.status !== 200) {
      return Promise.reject(resp);
    }
    return resp;
  },
  (error: any) => {
    loading && loading.close();
    return Promise.reject(error);
  }
);

const request = <T = Record<string,any>>(config: AxiosRequestConfig): Promise<PltRes<T>> => instance(config).then((resp: AxiosResponse) => resp.data);

export default request;
